// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdownLabel {
  font-size: 16px;
  margin-top: 8px;
  margin-bottom: 5px;
  font-weight: 500;
  margin-right: 3%;
  width: 20%;
  margin-left: 9%;
  color: #797979;
  font-family: "Ruda", sans-serif;
}

.dropdownLabel::after {
  content: "*";
  color: #797979;
  margin-left: 2px;
}

.dropdownLabelRed {
  font-size: 16px;
  margin-top: 8px;
  margin-bottom: 5px;
  font-weight: 500;
  margin-right: 3%;
  width: 20%;
  margin-left: 9%;
  color: red;
  font-family: "Ruda", sans-serif;
}

.dropdownLabelRed::after {
  content: "*";
  color: red;
  margin-left: 2px;
}

.dropdownSelectNotReq {
  font-size: 16px;
  margin-top: 8px;
  margin-bottom: 5px;
  font-weight: 500;
  margin-right: 3%;
  width: 20%;
  margin-left: 9%;
  color: #797979;
  font-family: "Ruda", sans-serif;
}

.dropdownSelect {
  box-sizing: border-box;
  width: 52%;
  position: relative;
  max-height: 35px;
  padding-right: 15px;
  padding-left: 15px;
  color: #555;
  font-family: "Ruda", sans-serif;
  font-size: 13px;
  line-height: 1.42857143;
  margin-left: 4%;
  margin-right: 11%;
  border-radius: 4px;
  border: 1px solid #ccc;
  outline-color: #68dff0;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
}

.dropdownSelect:disabled {
  cursor: not-allowed;
}

.dropdownDiv {
  display: flex;
  width: 100%;
  margin-bottom: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/components/SubComponents/Dropdown/dropdown.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,UAAU;EACV,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,+BAA+B;EAC/B,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,wEAAwE;AAC1E;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB","sourcesContent":[".dropdownLabel {\n  font-size: 16px;\n  margin-top: 8px;\n  margin-bottom: 5px;\n  font-weight: 500;\n  margin-right: 3%;\n  width: 20%;\n  margin-left: 9%;\n  color: #797979;\n  font-family: \"Ruda\", sans-serif;\n}\n\n.dropdownLabel::after {\n  content: \"*\";\n  color: #797979;\n  margin-left: 2px;\n}\n\n.dropdownLabelRed {\n  font-size: 16px;\n  margin-top: 8px;\n  margin-bottom: 5px;\n  font-weight: 500;\n  margin-right: 3%;\n  width: 20%;\n  margin-left: 9%;\n  color: red;\n  font-family: \"Ruda\", sans-serif;\n}\n\n.dropdownLabelRed::after {\n  content: \"*\";\n  color: red;\n  margin-left: 2px;\n}\n\n.dropdownSelectNotReq {\n  font-size: 16px;\n  margin-top: 8px;\n  margin-bottom: 5px;\n  font-weight: 500;\n  margin-right: 3%;\n  width: 20%;\n  margin-left: 9%;\n  color: #797979;\n  font-family: \"Ruda\", sans-serif;\n}\n\n.dropdownSelect {\n  box-sizing: border-box;\n  width: 52%;\n  position: relative;\n  max-height: 35px;\n  padding-right: 15px;\n  padding-left: 15px;\n  color: #555;\n  font-family: \"Ruda\", sans-serif;\n  font-size: 13px;\n  line-height: 1.42857143;\n  margin-left: 4%;\n  margin-right: 11%;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n  outline-color: #68dff0;\n  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;\n}\n\n.dropdownSelect:disabled {\n  cursor: not-allowed;\n}\n\n.dropdownDiv {\n  display: flex;\n  width: 100%;\n  margin-bottom: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
